var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgLongArrowAltRight(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M27.576 11.355a1.104 1.104 0 010 1.547l-5.672 6.047c-.422.422-.984.703-1.593.703-1.22 0-2.157-.984-2.157-2.203v-1.547L6.53 15.856a2.62 2.62 0 01-2.625-2.626v-2.25c0-1.406 1.172-2.625 2.625-2.625h11.625V6.81c0-1.22.938-2.204 2.157-2.204.609 0 1.171.282 1.593.704l5.672 6.046zm-7.172-4.359V9.48a1.11 1.11 0 01-1.125 1.125H6.53a.37.37 0 00-.375.375v2.25c0 .235.14.375.375.375h12.75c.282 0 .563.141.797.329.188.234.328.515.328.796v2.532l4.828-5.157-4.828-5.109z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgLongArrowAltRight);
export default ForwardRef;
